import { Helmet } from "react-helmet";
import Navbar from "../components/universal/navbar";
import Header from "../components/contact-us/hero";
import ContactForm from "../components/contact-us/contact-form";
import Footer from "../components/universal/footer";
import { Navigate } from "react-router-dom";
function Index() {
  return <Navigate to="/" />;
  // return (
  //   <div>
  //     <Helmet>
  //       <title>Dental Implants in Ilkley | Contact Us</title>
  //       <link
  //         rel="canonical"
  //         href="https://www.dentalimplants-ilkley.com/contact-us"
  //       />
  //       <meta
  //         name="description"
  //         content="Get in touch with Dental Implants Ilkley today. Call, email, or visit us to schedule your implant consultation or inquire about our advanced dental treatments."
  //       />
  //     </Helmet>
  //     <Navbar />
  //     <Header />
  //     <ContactForm />
  //     <Footer />
  //   </div>
  // );
}

export default Index;
